/**
*   SEE EXAMPLE AT: ~/js/docs/components/Modal.md
*/

import modal from '~/js/modules/magnific-popup';

const { Fragment, Component } = React;


class Modal extends Component {

    static getDerivedStateFromProps(newProps, state) {

        const titleHasChanged = (state.title !== newProps.title);
        const contentHasChanged = (state.content !== newProps.content);

        if (titleHasChanged || contentHasChanged) {

            return {
                ...newProps
            };
        }

        return null;
    }

    state = {
        title: '',
        content: '',
    };

    componentDidMount() {

        modal();
    }

    render() {

        const { title, content } = this.state;
        const { id } = this.props;

        return (
            <div id={ id } className="modal-window mfp-hide">
                {
                    this.props.children ?
                    this.props.children : (
                        <Fragment>
                            <h3 className="mdp-title">
                                { title }
                            </h3>
                            <div dangerouslySetInnerHTML={{__html: content}}/>
                        </Fragment>
                    )
                }
            </div>
        );
    }
}

Modal.defaultProps = {
    id: 'v12-modal',
};

export default Modal;
